import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AnimationOptions } from 'ngx-lottie';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'secure-account-completed',
  templateUrl: './secure-account-completed.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SecureAccountCompletedComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<SecureAccountCompletedComponent>) {}

  securedAnimationOptions: AnimationOptions = {
    path: 'assets/lottie/secured.json',
  };

  ngOnInit(): void {}

  closeDialog() {
    this.dialogRef.close({
      confirmation: true,
    });
  }
}
